<template>
    <form ref="form" @submit.prevent>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <div class="radio-info-content">
            <span class="title">정산설정</span>
            <div class="info-area">
                <div class="left-box">
                    <div class="input-line col">
                        <span class="tit">터치출석을 이용하여 회원 출석 시</span>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="data.billPosAttendAutoYn"
                                    :value="true"
                                    checked
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-1-2"
                                    v-model="data.billPosAttendAutoYn"
                                    :value="false"
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-2">단순 출결처리</label>
                            </div>
                        </div>
                    </div>
                    <div class="input-line col">
                        <span class="tit">회원예약 어플에서 직접 출결 승인 시</span>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-2-1"
                                    v-model="data.billAppAttendAutoYn"
                                    :value="true"
                                    checked
                                    name="radio-2"
                                    type="radio"
                                />
                                <label for="radio-2-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-2-2"
                                    v-model="data.billAppAttendAutoYn"
                                    :value="false"
                                    name="radio-2"
                                    type="radio"
                                />
                                <label for="radio-2-2">단순 출결처리</label>
                            </div>
                        </div>
                    </div>
                    <div class="input-line col">
                        <span class="tit">강사가 결석처리 했을 경우</span>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-3-1"
                                    v-model="data.billStaffOffAutoYn"
                                    :value="true"
                                    name="radio-3"
                                    type="radio"
                                />
                                <label for="radio-3-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-3-2"
                                    v-model="data.billStaffOffAutoYn"
                                    :value="false"
                                    checked
                                    name="radio-3"
                                    type="radio"
                                />
                                <label for="radio-3-2">단순 결석처리</label>
                            </div>
                        </div>
                    </div>
                    <div class="input-line col">
                        <span class="tit">회원 예약 어플 출결 사용</span>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-4-1"
                                    v-model="data.attendanceCheckInApp"
                                    :value="true"
                                    name="radio-4"
                                    type="radio"
                                />
                                <label for="radio-4-1">사용</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input
                                    id="radio-4-2"
                                    v-model="data.attendanceCheckInApp"
                                    :value="false"
                                    checked
                                    name="radio-4"
                                    type="radio"
                                />
                                <label for="radio-4-2">미사용</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <span class="tit">자동정산</span>
                    <p class="txt">자동으로 정산완료 됩니다.</p>
                    <span class="tit">단순출결처리</span>
                    <p class="txt">출석, 결석처리만 되며 정산을 하기 위해서는 관리자가 정산처리를 해주어야 합니다.</p>
                    <span class="tit">단순결석처리</span>
                    <p class="txt">정산을 하기 위해서는 관리자가 정산처리를 해주어야 합니다.</p>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button :disabled="isLoading" class="com-btn blue" type="button" @click="save">저장</button>
        </div>
    </form>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingCenterAccount',
    components: { LoadingSpinner },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            data: {},
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            if (!this.centerId) return;
            this.isLoading = true;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    const telNo = (this.data.telNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (telNo) {
                        this.data.telNo1 = telNo[1];
                        this.data.telNo2 = telNo[2];
                        this.data.telNo3 = telNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    console.log(res);
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                return;
            }

            this.isLoading = true;
            api.put(`/admin/api/center/${this.centerId}`, this.data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss"></style>
